import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export default axios.create({
  baseURL: BASE_URL,
});

const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json", "env": "test" },
  withCredentials: true,
});

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_PATH = "/admin";
const BUSINESS_PATH = "admin/business";
const USER_PATH = "admin/user";
const USER = "/user"
const VENDOR_PATH = "vendor"
const PAYOUT_PATH = "payout"
const IMAGE_PATH = "uploadImage";

const AUTH_API_URL = {
  login: path(ROOTS_PATH, "/login"),
  register: path(ROOTS_PATH, "/register"),
  signupVerifyOTP: path(ROOTS_PATH, "/otp/verify/signup"),
  resendOTP: path(ROOTS_PATH, "/otp/resend"),
  getOtp: path(ROOTS_PATH, "/otp/get"),
  verifyOtp: path(ROOTS_PATH, "/otp/verify"),
  forgotPassword: path(ROOTS_PATH, "/password/forgot"),
  refreshToken: path(ROOTS_PATH, "/refreshToken"),
  logout: path(ROOTS_PATH, "/logout"),
};

const INDIVIDUAL_API_URL = {
  profile: path(ROOTS_PATH, "/profile"),
  profileUpload: path(ROOTS_PATH, "/image/upload"),
  documentUpload: path(ROOTS_PATH, "/file/upload"),
  idVerify: path(ROOTS_PATH, "/profile/document"),
  permission: path(ROOTS_PATH, "/profile/setting"),
  reference: path(ROOTS_PATH, "/profile/reference"),
};

const BUSINESS_API_URL = {
  getBusinessList: path(BUSINESS_PATH, "/list"),
  getBusiness: path(ROOTS_PATH, "/businesses/lists/"),
  businessApprove: path(BUSINESS_PATH, "/approve/"),
  categoryList: path(BUSINESS_PATH, "/category"),
  uploadFile: path(BUSINESS_PATH, "/upload/image"),
  addBusiness: path(BUSINESS_PATH, ""),
  businessIdVerify: path(BUSINESS_PATH, "/verify/document"),
  businessPermission: path(BUSINESS_PATH, "/setting"),
  businessReference: path(BUSINESS_PATH, "/references"),
  businessUpdate: path(BUSINESS_PATH, "/"),
  addBusinessAddress: path(BUSINESS_PATH, "/addresses"),
  getBusinessAddress: path(BUSINESS_PATH, "/address/"),
  updateBusinessAddress: path(BUSINESS_PATH, "/address"),
  deteleBusinessAddress: path(BUSINESS_PATH, "/address/"),
  businessBulkAddress: path(BUSINESS_PATH, "/mul/address")
};


const USER_API_URL = {
  dashboard: path(ROOTS_PATH, "/dashboard"),
  chartData: path(ROOTS_PATH, "/chartData"),

  //getBusinessList: path(BUSINESS_PATH, "/"),

  regUserList: path(ROOTS_PATH, "/registerUserList"),
  regUserEdit: path(USER_PATH, "/editUser"),
  deleteReqUserList: path(ROOTS_PATH, "/deleteAccountUserList"),
  regUserUpdate: path(USER_PATH, "/updateUser"),
  regUserDelete: path(USER_PATH, "/deleteUser/"),
  regUserVerify: path(USER_PATH, "/userVerify/"),
  userInactive: path(USER_PATH, "/userInactive/"),
  userOrderdetail: path(ROOTS_PATH, "/userOrderDetail/"),

  subAdminList: path(ROOTS_PATH, "/subAdminList"),
  addSubAdmin: path(ROOTS_PATH, "/addSubAdmin"),
  subAdminEdit: path(ROOTS_PATH, "/editSubAdmin"),
  updateSubAdmin: path(ROOTS_PATH, "/updateSUbAdmin"),
  deleteSubAdmin: path(ROOTS_PATH, "/deleteSubAdmin/"),
  inactiveSubAdmin: path(ROOTS_PATH, "/subAdminInactive/"),

  getProfile: path(ROOTS_PATH, "/getProfile"),
  updateprofile: path(ROOTS_PATH, "/updateProfile"),
  changePassword: path(ROOTS_PATH, "/changePassword")
}

const TRACE_API_URL = {
  getTraceRequest: path(ROOTS_PATH, "/trace/request/pending"),
  getTraceHistory: path(ROOTS_PATH, "/trace/request"),
  updatePandingRequest: path(ROOTS_PATH, "/trace/request/approve/"),
}

const CATEGORY_API_URL = {
  addCategory: path(ROOTS_PATH, "/foodCategoryAdd"),
  updateCategory: path(ROOTS_PATH, "/foodCategoryUpdate/"),
  getCategory: path(ROOTS_PATH, "/getFoodCategory"),
  deleteCategory: path(ROOTS_PATH, "/deleteFoodCategory/"),
  changeStatus: path(ROOTS_PATH, "/activeInactivemainCategory/"),
  changeFoodStatus: path(ROOTS_PATH, "/editStatusFoodCategory/"),
  changegroceryStatus: path(ROOTS_PATH, "/inactiveGroceryCategory/"),

  addGroceryCategory: path(ROOTS_PATH, "/groceryCategoryAdd"),
  updateGroceryCategory: path(ROOTS_PATH, "/groceryCategoryUpdate/"),
  getGroceryCategory: path(ROOTS_PATH, "/getGroceryCategory"),
  deleteGroceryCategory: path(ROOTS_PATH, "/deleteGroceryCategory/"),

  getMainCategory: path(ROOTS_PATH, "/getMainCategory"),
  addMainCategory: path(ROOTS_PATH, "/mainCategoryAdd"),
  updateMainCategory: path(ROOTS_PATH, "/mainCategoryUpdate/"),
  deleteMainCategory: path(ROOTS_PATH, "/deleteMainCategory/"),
  uploadImage: path("/", "uploadImage/"),

  getSupportTicket: path(ROOTS_PATH, "/getSupportTicketList")
}

const ROLE_API_URL = {
  getRoleList: path(ROOTS_PATH, "/getRole"),
  addRole: path(ROOTS_PATH, "/roleAdd"),
  updateRole: path(ROOTS_PATH, "/roleUpdate/"),
  deleteRole: path(ROOTS_PATH, "/deleteRole/"),
  changeStatus: path(ROOTS_PATH, "/activeInactiveRole/"),
}
const COUPON_URI = {
  getCoupon: path(ROOTS_PATH, "/getCoupon"),
  addcoupon: path(ROOTS_PATH, "/addCoupon"),
  couponupdate: path(ROOTS_PATH, "/updateCoupon"),
  deletecoupon: path(ROOTS_PATH, "/deleteCoupon/"),
  changeStatus: path(ROOTS_PATH, "/couponInactive"),
}
const NOTIFICATION_API_URL = {
  getNotification: path(ROOTS_PATH, "/getNotification"),
  getRoleForNotification: path(ROOTS_PATH, "/getRoleForNotification"),
  addNotification: path(ROOTS_PATH, "/notificationAdd"),
  updateNotification: path(ROOTS_PATH, "/notificationUpdate/"),
  deleteNotification: path(ROOTS_PATH, "/deleteNotification/"),
}
const PERMISSION_API_URL = {
  getPermissionList: path(ROOTS_PATH, "/getPermission"),
  addPermission: path(ROOTS_PATH, "/permissionAdd"),
  updatePermission: path(ROOTS_PATH, "/permissionUpdate/"),
  deletePermission: path(ROOTS_PATH, "/deletePermission/"),
  getAppVersion: path(ROOTS_PATH, "/getAppVersion"),
  addAppVersion: path(ROOTS_PATH, "/appVersionAdd"),
  updateAppVersion: path(ROOTS_PATH, "/appVersionUpdate/"),
  changeStatus: path(ROOTS_PATH, "/activeInactivePermission/"),
  getPasswordDetail: path(ROOTS_PATH, "/getPasswordDetail"),
  addUpdatePassword: path(ROOTS_PATH, "/passwordAddUpdate"),
}

const CONFIG_FIELD = {
  configurableFields: path(ROOTS_PATH, "/"),
  getConfigFields: path(ROOTS_PATH, "/configurable/field"),
  addConfigFields: path(ROOTS_PATH, "/configurable/field"),
}
const VENDOR_API_URL = {
  getVendorList: path(ROOTS_PATH, "/listVendor"),
  getVendorPendingList: path(ROOTS_PATH, "/notUploadedPendingKyc"),
  getPendingBankRequest: path(ROOTS_PATH, "/getPendingBankRequest"),
  getChangeBankRequest: path(ROOTS_PATH, "/getChangeBankRequest"),
  vendorAdd: path(ROOTS_PATH, "/addVendor"),
  vendorRequestStatusChange: path(ROOTS_PATH, "/vendorRequestStatusChange/"),
  vendorInactive: path(ROOTS_PATH, "/vendorInactive/"),
  approvebank: path(ROOTS_PATH, "/approveBank/"),
  charityInactive: path(ROOTS_PATH, "/ngoInactive/"),
  vendorVerify: path(ROOTS_PATH, "/vendorVerify/"),
  vendorUpdate: path(ROOTS_PATH, "/updateVendor/"),
  vendorDelete: path(ROOTS_PATH, "/deleteVendor/"),
  transactionAdd: path(ROOTS_PATH, "/add_payout_transaction/"),
  makePayoutProgress: path(ROOTS_PATH, "/changePayoutProgress"),
  // addMainCategory: path(ROOTS_PATH, "/mainCategoryAdd"),
  // updateMainCategory: path(ROOTS_PATH, "/mainCategoryUpdate/"),
  getCharityList: path(ROOTS_PATH, "/listNGOCharity"),
  getEventList: path(ROOTS_PATH, "/getEventList"),
  getPayout: path(ROOTS_PATH, "/getPendingPayout"),
  transactionList: path(ROOTS_PATH, "/getTransaction"),
  eventTransactionList: path(ROOTS_PATH, "/getEventTransaction"),
  DonationTransactionList: path(ROOTS_PATH, "/getDonationTransactionList"),
  uploadImage: path("/", "uploadImage/"),
  uploadEventImage: path(IMAGE_PATH, "/eventImage"),
  getVendorViewData: path(ROOTS_PATH, "/getVendorViewData"),

  getOrderByVendor: path(ROOTS_PATH, "/getOrderByVendor"),
  getProductByVendor: path(ROOTS_PATH, "/getProductByVendor"),

  getApprovedPayout: path(ROOTS_PATH, "/getApprovedPayout"),
  transactionList: path(ROOTS_PATH, "/getTransactionList"),

  approvePayout: path(ROOTS_PATH, "/approvePayout"),
  makeAllPayoutInProgress: path(ROOTS_PATH, "/makeAllPayoutInProgress"),
  getVendorByKycStatus: path(ROOTS_PATH, "/getVendorByKycStatus"),
  ChangeBankDetails: path(ROOTS_PATH, "/ChangeBankDetails/"),
  getEventByVendor: path(ROOTS_PATH, "/getEventByVendor"),
  donationByVendorId: path(ROOTS_PATH, "/donationByVendorId"),
  getCharityListByVendor: path(ROOTS_PATH, "/getCharityListByVendor"),
  updateEvent: path(VENDOR_PATH, "/updateEvent"),
}
const ORDER_API_URL = {
  changeFoodItemStatus: path(ROOTS_PATH, "/foodItemInactive/"),
  changeGroceryItemStatus: path(ROOTS_PATH, "/groceryItemInactive/"),
  getFoodDishList: path(ROOTS_PATH, "/getFoodDishList"),
  getGroceryList: path(ROOTS_PATH, "/getGroceryList"),
  getFoodOrder: path(ROOTS_PATH, "/getTypeWiseOrder"),
  getGroceryOrder: path(ROOTS_PATH, "/getTypeWiseOrder"),
  getTypeWiseOrder: path(ROOTS_PATH, "/getTypeWiseOrder"),
  placedOrder: path(ROOTS_PATH, "/placedOrder"),

  getDisputedOrder: path(USER, "/getDisputedOrder"),
  changeStatus: path(USER, "/disputedOrderStatus/"),
}
const ADMIN_FEE = {
  getAdminfees: path(ROOTS_PATH, "/getAdminFee"),
  addAdminfee: path(ROOTS_PATH, "/addAdminFee"),
  deleteadminfee: path(ROOTS_PATH, "/deleteAdminfee/"),
  updateadminfee: path(ROOTS_PATH, "/updateAdminFee/"),
  changeStatus: path(ROOTS_PATH, "/adminfeeInactive/"),
}
const SUPPORT_PATH = {
  getChatMessage: path(ROOTS_PATH, "/getChatMessage"),
  editSupportRequest: path(ROOTS_PATH, "/support-ticket/edit"),
  getSupportSubject: path(ROOTS_PATH, "/supportSubject"),
  addSupportSubject: path(ROOTS_PATH, "/addSupportSubject"),
  updateSupportSubject: path(ROOTS_PATH, "/updateSupportSubject/"),
  deleteSupportSubject: path(ROOTS_PATH, "/deleteSupportSubject/"),
  changeTicketStatus: path(ROOTS_PATH, "/changeTicketStatus/"),
  sendMessage: path(ROOTS_PATH, "/sendMessage")
}
const CMS_API_URL = {
  getPages: path(ROOTS_PATH, "/getPage"),
  addStaticPage: path(ROOTS_PATH, "/pageAdd"),
  editStaticPage: path(ROOTS_PATH, "/pageUpdate/"),
  changeStatus: path(ROOTS_PATH, "/pageInactive/"),
  deleteCmsPage: path(ROOTS_PATH, "/deleteCmsPages/"),
  getPayoutOrderList: path(ROOTS_PATH, "/getPayoutOrderList"),
  getPayoutEventBooking: path(ROOTS_PATH, "/getPayoutEventBooking"),
  getPayoutDonation: path(ROOTS_PATH, "/getPayoutDonation")

}
const FAQ_API_URL = {
  getFaq: path(ROOTS_PATH, "/getFaq"),
  addFaq: path(ROOTS_PATH, "/faqAdd"),
  editFaq: path(ROOTS_PATH, "/faqUpdate/"),
  changeStatus: path(ROOTS_PATH, "/faqInactive/"),
  deleteFaq: path(ROOTS_PATH, "/deleteFaq/"),

}
const PAYOUT_API_URL = {

  getPayoutList: path(ROOTS_PATH, "/getPayoutList"),
}
const SUBSCRIBER_API_URL = {

  subscriberList: path(ROOTS_PATH, "/subscriberList"),
  feedback: path(ROOTS_PATH, "/getUserSupportTicket"),
  
}

const ADS_PATH = {
  getAdvertisement: path(ROOTS_PATH, "/listAdvertise"),
  addAdvertisment: path(ROOTS_PATH, "/addAdvertise"),
  advertisementUpdate: path(ROOTS_PATH, "/advertisementUpdate"),
  editStaticPage: path(ROOTS_PATH, "/pageUpdate/"),
  AdsRequestStatusChange: path(ROOTS_PATH, "/AdsRequestStatusChange/"),
  AdsPaymentStatusChange: path(ROOTS_PATH, "/AdsPaymentStatusChange/"),
  changeStatus: path(ROOTS_PATH, "/AdsStatusChange/"),
  deleteCmsPage: path(ROOTS_PATH, "/deleteCmsPages/"),
  getVendors: path(ROOTS_PATH, "/vendorBusinessList/"),
  deleteAdvertise: path(ROOTS_PATH, "/deleteAdvertise/"),
  getEvents: path(ROOTS_PATH, "/getEventsByVendorId"),
  getNgos: path(ROOTS_PATH, "/getCharityByVendorId")
}

export {
  axiosPrivate,
  AUTH_API_URL,
  INDIVIDUAL_API_URL,
  BUSINESS_API_URL,
  USER_API_URL,
  CATEGORY_API_URL,
  TRACE_API_URL,
  ROLE_API_URL,
  CONFIG_FIELD,
  PERMISSION_API_URL,
  VENDOR_API_URL,
  COUPON_URI,
  NOTIFICATION_API_URL,
  ORDER_API_URL,
  ADMIN_FEE,
  SUPPORT_PATH,
  CMS_API_URL,
  ADS_PATH,
  PAYOUT_API_URL,
  FAQ_API_URL,
  SUBSCRIBER_API_URL
}